var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',_vm._g(_vm._b({staticClass:"mb-1",attrs:{"active":_vm.$root.RootProgressBar,"color":"primary","fixed":"","indeterminate":""}},'v-progress-linear',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }